// Shared import() functions for the two DU Daily booking-flow chunks, so
// App.js's lazy() and DriveULandingPage's prefetch-on-mount both resolve to
// the exact same chunk (not a duplicate fetch). Called early from the
// landing page so the chunk is already cached by the time the user picks
// Round Trip / One Way, instead of showing a loader on that transition.
//
// webpackPrefetch makes the browser fetch these via <link rel="prefetch">
// at low network priority, instead of a normal-priority fetch that competes
// for bandwidth with the landing page's own critical resources (these two
// chunks are ~700KB each - without this they were measurably starving the
// landing page's own chunk/images/Maps script on real network traces).
export const importDriveuDaily = () =>
  import(/* webpackPrefetch: true */ "../pages/DriveuDaily/DriveuDaily");

export const importDUOneWayBooking = () =>
  import(
    /* webpackPrefetch: true */ "../DriveUDaily/DUOneWayBooking/DUOneWayBooking"
  );
